var React = require('react');

function CircleCheckMark (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#a)","key":0},React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0 10.5C0 4.977 4.477.5 10 .5s10 4.477 10 10-4.477 10-10 10-10-4.477-10-10Zm13.703-1.86a.77.77 0 1 0-1.252-.895l-3.319 4.646-1.665-1.665a.77.77 0 0 0-1.088 1.087l2.308 2.307a.769.769 0 0 0 1.17-.096l3.846-5.385Z","fill":"currentColor"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"a"},React.createElement("path",{"fill":"#fff","transform":"translate(0 .5)","d":"M0 0h20v20H0z"})))]);
}

CircleCheckMark.defaultProps = {"width":"20","height":"21","fill":"none"};

module.exports = CircleCheckMark;

CircleCheckMark.default = CircleCheckMark;
